import map from 'lodash/map';
import flatMap from 'lodash/flatMap';

import data from "../models/goods.json";
import { removeZeroHS, writeHS, Track, ELEMENT_TYPE } from "../utils/utils";

const $ = window.$;
export class Classification {
  constructor(id, countryCode, description, hsCode, rawHs, imageUrl, parent, rawParent, path, selectable, uom, section, isGroup, simplePath, code, fullDescription) {
    this.id = id;
    this.countryCode = countryCode;
    this.description = description;
    this.fullDescription = fullDescription
    this.hsCode = hsCode;
    this.rawHS = rawHs;
    this.imageUrl = imageUrl;
    this.parent = parent;
    this.rawParent = rawParent;
    this.path = path;
    this.selectable = selectable;
    this.uom = uom;
    this.section = section;
    this.isGroup = isGroup;
    this.simplePath = simplePath;
    this.code = code;
  }
  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      const section = Classification.getSection(input.hs_code);
      let parent = input.parent;
      if (!parent) {
        if (removeZeroHS(input.hs_code).length === 2) {
          parent = section.id;
        }
      }
      const path = Classification.fromApiArray(input.path);
      return new Classification(
        input.id,
        input.country_code,
        input.description,
        (input.hs_code + ''),
        input.hs_code,
        input.image_url,
        (parent + ''),
        input.parent,
        path,
        input.selectable,
        input.oum,
        section,
        input.is_group,
        map(path, function (item) { return item.code; }),
        input.code,
        input.full_description
      )
    }
    return new Classification();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => Classification.fromApiObject(item));
    }
    if (input && typeof (input) === "object") {
      return [Classification.fromApiObject(input)];
    }
    return [];
  }

  static getSection(hsCode) {
    const code = (hsCode + "").substring(0, 2) * 1;
    let section = {};
    if (code <= 5) {
      section = data[0];
    }
    if (code > 5 && code <= 14) {
      section = data[1];
    }
    if (code === 15) {
      section = data[2];
    }

    if (code > 15 && code <= 24) {
      section = data[3];
    }

    if (code > 24 && code <= 27) {
      section = data[4];
    }

    if (code > 27 && code <= 38) {
      section = data[5];
    }

    if (code > 38 && code <= 40) {
      section = data[6];
    }

    if (code > 40 && code <= 43) {
      section = data[7];
    }

    if (code > 43 && code <= 46) {
      section = data[8];
    }

    if (code > 46 && code <= 49) {
      section = data[9];
    }

    if (code > 49 && code <= 63) {
      section = data[10];
    }

    if (code > 63 && code <= 67) {
      section = data[11];
    }

    if (code > 67 && code <= 70) {
      section = data[12];
    }

    if (code === 71) {
      section = data[13];
    }

    if (code > 71 && code <= 83) {
      section = data[14];
    }

    if (code > 83 && code <= 85) {
      section = data[15];
    }

    if (code > 85 && code <= 89) {
      section = data[16];
    }

    if (code > 89 && code <= 92) {
      section = data[17];
    }

    if (code === 93) {
      section = data[18];
    }

    if (code > 93 && code <= 96) {
      section = data[19];
    }

    if (code > 96 && code <= 99) {
      section = data[20];
    }

    return section;
  }

  static checkHighlight(current, item) {
    if (!current) {
      return '';
    }

    if (Array.isArray(current)) {
      if (map(current, "code").includes(item.code)) {
        return ' current';
      }
      if (flatMap(map(current, "simplePath")).includes(item.code)) {
        return ' parent';
      }
    } else {
      if (current.code === item.code) {
        return ' current';
      }
      if (current.simplePath.includes(item.code)) {
        return ' parent';
      }
    }
    return '';
  }

  render(parent, currentData = window.currentData) {
    if (this.hsCode && !$(parent).find(`[type='section'][data-id='${this.section.id}']`).length) {
      const detail = this.section.section.chapterFrom === this.section.section.chapterTo ? this.section.section.chapterFrom : `${this.section.section.chapterFrom} - ${this.section.section.chapterTo}`;
      const parentSection = (Array.isArray(currentData) && map(currentData, "section.id").includes(this.section.id)) || (currentData && currentData.section.id === this.section.id) ? " parent" : "";
      const sectionElement = $(`
        <div class="item-tree${parentSection}" selectable='${true}' code='${this.section.id}' type='section' data-id='${this.section.id}'>
          <div class="label-box">
            <div class="arrow"></div>
            <div class="info-box">
              <div class="text">${this.section.description}</div>
              <div class="data">
                <span>${this.section.section.description}</span>
                <span class="detail">${detail}</span>
              </div>
            </div>
          </div>
          <div class="sub"></div>
        </div>
      `);
      sectionElement.find('.label-box').attr("tfc", Track.genNormalTrack("", "hs-code-tree", "toggle-section" + this.section.id, ELEMENT_TYPE.BUTTON, "", 3000, 0, 1));
      sectionElement.find('.label-box').attr("tfh", Track.genNormalTrack("", "hs-code-tree", "toggle-section" + this.section.id, ELEMENT_TYPE.BUTTON, "", 3000, 0, 1));
      $(parent).append(sectionElement);
    }
    if (this.path.length) {
      for (let i = 0; i < this.path.length; i++) {
        const item = this.path[i];
        item.render(parent, currentData);
      }
    } else {
      if (!$(parent).find(`[code='${this.code}'][data-id='${this.hsCode}'][selectable='${this.selectable}'][parent='${this.parent}'][is_group='${this.isGroup}']`).length) {
        let realParent = $(parent).find(`[code='${this.parent}'] > .sub`);
        const element = $(`
          <div class="item-tree${Classification.checkHighlight(currentData, this)}" ${!this.selectable && !this.isGroup ? `title="View Commodity Tariff Information"` : ""} code='${this.code}' selectable='${this.selectable}' parent='${this.parent}' data-raw='${this.rawHS}' is_group='${this.isGroup}' type='node' data-id='${this.hsCode}'>
            <div class="border-div"></div>
            <div class="label-box">
              <div class="arrow"></div>
              <div class="info-box">
                <div class="text">${this.description}</div>
                <div class="data">
                  <span class="detail">${writeHS(this.selectable ? removeZeroHS(this.hsCode) : this.hsCode)}</span>
                </div>
              </div>
            </div>
            <div class="sub"></div>
            <div class="border-line"></div>
          </div>
        `);
        element.find('.label-box').attr("tfc", Track.genNormalTrack("", "hs-code-tree", "toggle-" + this.code, ELEMENT_TYPE.BUTTON, "", 3000, 0, 1));
        element.find('.label-box').attr("tfh", Track.genNormalTrack("", "hs-code-tree", "toggle-" + this.code, ELEMENT_TYPE.BUTTON, "", 3000, 0, 1));
        realParent.first().append(element);
      }
    }
  }

  static renderGoods(parent) {
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      const detail = item.section.chapterFrom === item.section.chapterTo ? item.section.chapterFrom : `${item.section.chapterFrom} - ${item.section.chapterTo}`;
      const parentSection = map(window.currentData, "section.id").includes(item.id) ? ` parent${data.length === 1 ? " active" : ""}` : "";

      $(parent).append($(`
        <div class="item-tree${parentSection}" selectable='${true}' code='${item.id}'  type='section' data-id='${item.id}'>
          <div class="label-box">
            <div class="arrow"></div>
            <div class="info-box">
              <div class="text">${item.description}</div>
              <div class="data">
                <span>${item.section.description}</span>
                <span class="detail">${detail}</span>
              </div>
            </div>
          </div>
          <div class="sub"></div>
        </div>
      `));
    }
    // for (let k = 0; k < window.currentData.length; k++) {
    //   const current = window.currentData[k];
    //   current.render(parent);
    // }
  }
}